import { flatMap, unionBy } from 'lodash';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import apiCall from 'shared/utils/apiCall';
import { attachmentsConfig } from 'modules/appointmentInfo/constants/attachmentsConfig';

import * as services from '../services/organizationConfig';
import createAction from './index';


export const FETCH_ORGANIZATION_CONFIG = createAsyncAction(createAction('FETCH_ORGANIZATION_CONFIG'));

export const fetchOrganizationConfig = () => dispatch => {
  dispatch({ type: FETCH_ORGANIZATION_CONFIG.pending });

  const apiCallParams = {
    query: services.ORGANIZATION_CONFIG,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organization: { config } } }) => {
      const fileManagerConfig = config.fileManagerConfig.filter(i => i.fileType === 'CONSULTATION_ATTACHMENT');
      const mimeTypeSettings = flatMap(fileManagerConfig, 'mimeTypeSettings');
      const fileMetaDataConfig = unionBy(mimeTypeSettings, attachmentsConfig, 'mimeType');
      const { appointmentConfig, generalConfig, defaultPhoneCountryCode } = config;

      return dispatch({
        type: FETCH_ORGANIZATION_CONFIG.success,
        payload: {
          fileMetaDataConfig,
          appointmentConfig,
          generalConfig,
          defaultPhoneCountryCode,
        },
      });
    })
    .catch(err => dispatch(errorAction(FETCH_ORGANIZATION_CONFIG.failure, err)));
};
